// extracted by mini-css-extract-plugin
export default {"container":"YQ-z","topReviewHeading":"ZQ-z","criticalReview":"_Q-z","favorableReview":"aR-z","vsSeparator":"bR-z"};